import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Product} from '../../../../model/product';
import {FaqCategory} from '../../../../model/FaqCategory';
import {FaqCategoryService} from '../../../../services/faq-category.service';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {Contact} from '../../../../model/contact';
import {ProfileService} from "../../../../services/profile.service";

import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {BadgeComponent} from "../../../../components/common/badge/badge.component";
import {NgbTooltip} from "@ng-bootstrap/ng-bootstrap";
import {UserProductsFormGeneratorService} from "../../../../formulaires/user/user-products-list-form-generator.service";
import {DynamicFormComponent} from "../../../../components/common/dynamic-form/dynamic-form.component";
import { QuestionControlService } from 'src/app/components/common/fields/question-control.service';

@Component({
    selector: 'app-users-edit-modal-products-list',
    imports: [
    FaIconComponent,
    BadgeComponent,
    NgbTooltip,
    DynamicFormComponent
],
    templateUrl: './users-edit-modal-products-list.component.html',
    styleUrl: './users-edit-modal-products-list.component.scss'
})
export class UsersEditModalProductsListComponent implements OnInit {

  @Input() user: Contact;
  @Input() parentForm!: UntypedFormGroup;
  @Input() formName: string;

  products: Product[] = [];
  possibleProducts: Product[] = [];

  removedProducts: Product[] = [];
  addedProducts: { product: Product, transfert: string, formateur: string }[] = [];

  @Input()
  addProductMode: boolean = false;
  @Output()
  addProductModeChange = new EventEmitter<boolean>();

  constructor(private faqCategoryService: FaqCategoryService,
              private profileService: ProfileService,
              private userProductsFormGeneratorService: UserProductsFormGeneratorService,
              private qcs: QuestionControlService) {
  }

  questions: any;
  newform;

  ngOnInit(): void {
    this.profileService.getAllowedProducts().subscribe(products => {
      this.products = products;
      this.rebuildPossibleProducts();
    })
    this.parentForm.setControl('products', new UntypedFormControl({}));
  }

  getCategoryFromProduct(p: Product): FaqCategory {
    return this.faqCategoryService.getFromProduct(p);
  }

  getCategoryFromString(s: string): FaqCategory {
    return this.faqCategoryService.getFromString(s);
  }

  showNewProduct(): void {
    this.addProductMode = true;
    this.addProductModeChange.emit(true);
    this.newform.reset();
  }

  removeProduct(p: Product): void {
    this.removedProducts.push(p);
    this.rebuildFormValue();
  }

  reAddProduct(p: Product): void {
    this.removedProducts.splice(this.removedProducts.indexOf(p), 1)
    this.rebuildFormValue();
  }

  disableAddProductMode(): void {
    this.addProductMode = false;
    this.addProductModeChange.emit(false);
  }

  addToAskedProducts(): void {
    // find the good product to add to the list
    const found = this.possibleProducts.find(p => p.tag === this.newform.value.product);
    const newProduct = Object.assign({}, this.newform.value);
    newProduct.product = found;
    this.addedProducts.push(newProduct);
    this.disableAddProductMode();
    this.rebuildFormValue();
  }

  removeToAskedProducts(index): void {
    this.addedProducts.splice(index, 1);
    this.rebuildFormValue();
  }

  rebuildPossibleProducts(): void {
    this.possibleProducts.length = 0;
    this.possibleProducts.push(...this.products.filter(p => {
      return this.getCategoryFromProduct(p) &&
        this.user.contracts
          .map(c => c.product.tag.toLowerCase()).indexOf(p.tag.toLowerCase()) === -1 &&
        this.addedProducts
          .map(p2 => p2.product.tag.toLowerCase()).indexOf(p.tag.toLowerCase()) === -1;
    }));
    const productsOpt = this.possibleProducts
      .map(p => {
      return {key: p.tag, value: p.name};
    });
    this.userProductsFormGeneratorService.getQuestions(productsOpt).subscribe(q => {
      this.questions = q;
      this.newform = this.qcs.toFormGroup(this.questions, () => {});
      this.newform.reset();
    });
  }

  rebuildFormValue(): void {
    const products = {};
    for (let p of this.removedProducts) {
      products[p.tag.toLowerCase()] = {toAdd: false, accepted: false};
    }
    for (let p of this.addedProducts) {
      products[p.product.tag.toLowerCase()] = {toAdd: true, transfert: p.transfert, formateur: p.formateur, accepted: false}
    }
    this.parentForm.patchValue({products: products});
    this.rebuildPossibleProducts();
  }

}
